module.exports = __webpack_public_path__ + "1b2d7fcbca8ba15a1d7e499c1ef66c1c.jpg";